import { Box, Flex, Td, Tr } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import Input from './Input'
import { typeStore } from '../Utils/Helpers';
import Button from './Button';
import { AiOutlineCheck, AiOutlineClose } from 'react-icons/ai';
import QtyBar from './Qtybar';

export default function StockRow({ sn, productName, store, index, TakeData, onClick, type, qty, serviceable, unServiceable, shelfQty,shelfServiceable, shelfUnServiceable ,approve, reject }) {


    return (

        <Tr>
            {
                type === "typeStock" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td><QtyBar
                            qty={qty}
                            serviceable={serviceable}
                            unServiceable={unServiceable}
                        /></Td>

                        <Td>{typeStore(store)}</Td>
                        <Td ><Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={onClick}>Count Stock</Box></Td>
                    </>
                )
            }
            {
                type === "pendingStock" && (
                    <>
                        <Td>{sn}</Td>
                        <Td>{productName}</Td>
                        <Td>
                        <QtyBar
                            qty={qty}
                            serviceable={serviceable}
                            unServiceable={unServiceable}
                        />
                        </Td>
                        <Td>
                        <QtyBar
                            qty={shelfQty}
                            serviceable={shelfServiceable}
                            unServiceable={shelfUnServiceable}
                        />
                        </Td>
                      
                        <Td>{typeStore(store)}</Td>
                        <Td ><Flex justifyContent={"space-between"}>
                            <Box cursor="pointer" bg="teal" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={approve}> <AiOutlineCheck /></Box>
                            <Box cursor="pointer" bg="red" color="#fff" w='auto' textAlign={"center"} p="8px" rounded="8px" onClick={reject}> <AiOutlineClose /></Box>
                        </Flex>
                        </Td>
                    </>
                )
            }

        </Tr>

    )
}
